"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Modal = require("@insided/shared/uikit/Modal");

var _toKebabCase = require("@insided/shared/utils/toKebabCase");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var ScheduledConfirmationModal = function ScheduledConfirmationModal(props) {
  var schedule = props.schedule,
      isOpen = props.isOpen,
      onSend = props.onSend,
      _onClose = props.onClose,
      isScheduleButtonDisabled = props.isScheduleButtonDisabled;
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: isOpen,
    size: "small"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: "Ready to schedule this email campaign?",
    onClose: function onClose() {
      return _onClose();
    }
  }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("div", {
    className: (0, _toKebabCase.statelessFunctionNameToKebab)(ScheduledConfirmationModal.name)
  }, (0, _preact.h)("p", null, "Your email will be scheduled to be sent ", schedule.date, " ", schedule.time, " ", schedule.timeZone.title, "."))), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
    title: "Yes, schedule email",
    onClick: onSend,
    size: "medium",
    variant: "brand",
    className: "qa-schedule-email-campaign",
    disabled: isScheduleButtonDisabled,
    "data-track-type": "click",
    "data-element-name": "Yes, schedule email button"
  }), (0, _preact.h)(_Button.default, {
    title: "Cancel",
    onClick: _onClose,
    size: "medium",
    "data-track-type": "click",
    "data-element-name": "Cancel button"
  })));
};

var _default = ScheduledConfirmationModal;
exports.default = _default;